import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Text = (props) => {

    const {
        id,
        classes,
        text,
        display,
        textReplacements = {},
        isReplacementALink,
        path,
        path2,
        linkText,
        telText,
        symbol,
        symbolClassName,
        symbolPosition
    } = props;

    return (
        <Fragment>
            {display === 'block' ?
                <Fragment>
                    <p id={id} data-automation-id={id} className={classes && classes.join(' ')}>
                        {
                            !isReplacementALink &&( () => {
                                switch ( symbolPosition ) {
                                    case 'START':
                                        return (
                                            <Fragment>
                                                <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>
                                                <FormattedMessage
                                                    id={text}
                                                    values={{
                                                        ...textReplacements,
                                                        strong: function makeStrong(chunks){ return <strong>{ chunks }</strong>; },
                                                        linebreak: <br />,
                                                        p: function paragraph(chunks){ return <p>{ chunks }</p>; }
                                                    }}
                                                />
                                            </Fragment>
                                        );
                                    case 'END':
                                        return (
                                            <Fragment>
                                                <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>
                                                <FormattedMessage
                                                    id={text}
                                                    values={{
                                                        ...textReplacements,
                                                        strong: function makeStrong(chunks){ return <strong>{ chunks }</strong>; },
                                                        linebreak: <br />,
                                                        p: function paragraph(chunks){ return <p>{ chunks }</p>; }
                                                    }}
                                                />
                                            </Fragment>
                                        );
                                    default:
                                        return <FormattedMessage
                                            id={text}
                                            values={{
                                                ...textReplacements,
                                                strong: function makeStrong(chunks){ return <strong>{ chunks }</strong>; },
                                                linebreak: <br />,
                                                p: function paragraph(chunks){ return <p>{ chunks }</p>; },
                                                span: function renderSpan(chunks, spanClassName){return <span className={spanClassName}>{ chunks }</span>; }
                                            }}
                                        />;

                                }
                            } )()
                        }
                        {
                            isReplacementALink && ( () => {
                                switch ( symbolPosition ) {
                                    case 'START':
                                        return (
                                            <Fragment>
                                                <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>
                                                <FormattedMessage
                                                    id={text}
                                                    values={{
                                                        ...textReplacements,
                                                        link:(
                                                            <a
                                                                className="usa-link--external"
                                                                href={path}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <FormattedMessage id={linkText} values={{ ...textReplacements }} tagName='br'/>
                                                            </a>
                                                        )
                                                    }}
                                                />
                                            </Fragment>
                                        );

                                    case 'END':
                                        return (
                                            <Fragment>
                                                <FormattedMessage
                                                    id={text}
                                                    values={{
                                                        ...textReplacements,
                                                        link:(
                                                            <a
                                                                className="usa-link--external"
                                                                href={path}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <FormattedMessage id={linkText} values={{ ...textReplacements }}/>
                                                            </a>
                                                        )
                                                    }}
                                                />
                                                <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>
                                            </Fragment>
                                        );
                                    default:
                                        return <FormattedMessage
                                            id={text}
                                            values={{
                                                ...textReplacements,
                                                link: (
                                                    <a
                                                        className="usa-link--external"
                                                        href={path}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <FormattedMessage id={linkText} values={{ ...textReplacements }}/>
                                                    </a>
                                                ),
                                                tel: (
                                                    <a
                                                        href={path2}
                                                    >
                                                        <FormattedMessage id={telText} values={{ ...textReplacements }}/>
                                                    </a>
                                                ),
                                                strong: function makeStrong(chunks){ return <strong>{ chunks }</strong>; },
                                                linebreak: <br />,
                                                p: function paragraph(chunks){ return <p>{ chunks }</p>; }
                                            }}
                                        />;

                                }
                            } )()
                        }

                    </p>
                </Fragment>
                : <Fragment>
                    <span id={id} data-automation-id={id} className={classes && classes.join(' ')}>
                        <FormattedMessage id={ text } values={{ ...textReplacements }}/>
                    </span>
                </Fragment>
            }
        </Fragment>
    );
};

export default Text;